import {
  ArrowLeftRight,
  CircleCheck,
  CircleDashed,
  CirclePercent,
  CircleX,
  Coins,
  Truck,
  Warehouse,
  BadgeDollarSign,
} from "lucide-react";
import { cn } from "@/utils/cn";

type FilterIconProps = {
  className?: string;
};

export const StatusCreated = ({ className }: FilterIconProps) => {
  return <CircleDashed className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const StatusApproved = ({ className }: FilterIconProps) => {
  return <CircleDashed className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const StatusWaiting = ({ className }: FilterIconProps) => {
  return <CircleDashed className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const StatusShipping = ({ className }: FilterIconProps) => {
  return <Truck className={cn("h-4 w-4 text-amber-500", className)} />;
};

export const StatusShipped = ({ className }: FilterIconProps) => {
  return <Warehouse className={cn("h-4 w-4 text-amber-500", className)} />;
};

export const StatusPartiallyTreatedMerchant = ({
  className,
}: FilterIconProps) => {
  return <CircleDashed className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const StatusTreatedMerchant = ({ className }: FilterIconProps) => {
  return <CircleCheck className={cn("h-4 w-4 text-green-600", className)} />;
};

export const StatusError = ({ className }: FilterIconProps) => {
  return <CircleX className={cn("h-4 w-4 text-destructive", className)} />;
};

export const StatusPartiallyTreatedLogistician = ({
  className,
}: FilterIconProps) => {
  return <CircleDashed className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const StatusTreatedLogistician = ({ className }: FilterIconProps) => {
  return <CircleDashed className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const ResolutionRefund = ({ className }: FilterIconProps) => {
  return <Coins className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const ResolutionDiscount = ({ className }: FilterIconProps) => {
  return <CirclePercent className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const ResolutionExchange = ({ className }: FilterIconProps) => {
  return <ArrowLeftRight className={cn("h-4 w-4 text-gray-500", className)} />;
};

export const ResolutionExchangeCredit = ({ className }: FilterIconProps) => {
  return <BadgeDollarSign className={cn("h-4 w-4 text-gray-500", className)} />;
};
